import { css } from '@emotion/css'
import { colorsV1, colorsV2 } from '@ajaibid/components'
import stylesGlobal from '../style';

const styles = {
  newsImage: {
    width: 199,
    height: 117,
    objectFit: 'cover',
    borderRadius: 4,
  },
  newsLink: {
    color: stylesGlobal.neutral900,
    textDecoration: 'none',
  },
  newsPriceColumns: {
    width: 100,
    marginRight: 24,
    display: 'inline',
    marginTop: 16,
  },
  placeholderNewsImg: {
    height: 76,
    widows: 76,
    backgroundColor: stylesGlobal.neutral50,
    borderRadius: 8,
    width: '100%',
    objectFit: 'contain',
  },
  sideBarRight: {
    padding: 16,
    backgroundColor: stylesGlobal.neutral0,
    borderRadius: 4,
    border: `solid 1px ${stylesGlobal.neutral50}`,
    boxShadow: '0 2px rgba(0, 0, 1, 0.06)',
  },
  searchInputContainer: {
    backgroundColor: stylesGlobal.neutral0,
    border: 'solid 1px #cecece',
    borderRadius: 4,
  },
  searchInput: {
    backgroundColor: stylesGlobal.neutral0,
    width: 'calc(100% - 56px)',
    height: 40,
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 8,
    fontSize: 13,
    border: 'none',
    boxShadow: 'none',
  },
  searchIcon: {
    width: 24,
    marginRight: 8,
  },
  dataContainer: {
    height: 'calc(100vh - 42px - 24px - 140px)',
  },
  newsContent: {
    hover: {
      backgroundColor: stylesGlobal.red700,
    },
  },
  newsGrid: {
    maxWidth: 671,
  },
};

export default styles;

export const NewsItemPills = css`
  margin-right: 12px;
`

export const NewsItemPillsTextNeutral = (changePercentage) => {
  if (changePercentage > 0) {
    return css`color: ${colorsV2.G400};`;
  }
  if (changePercentage < 0) {
    return css`color: ${colorsV2.R500};`;
  }
  return css`color: ${colorsV1.MARKET_COLOR_GREY};`;
}

export const NewsItemPillsText = css`
  color: ${colorsV1.MARKET_COLOR_BASE}
`
